export const driftFastlaneCaptureFields = [
	{ name: 'email', value: 'email' },
	{ name: 'firstName', value: 'first_name' },
	{ name: 'lastName', value: 'last_name' },
	{ name: 'phone', value: 'phone_number' },
	{ name: 'projectedAnnualRevenue', value: 'projectedAnnualRevenue' },
	{ name: 'storeName', value: 'name' }
]
